import { getServerUri } from './getServerUri'

let cachedClientId = null

export const getClickupRedirectUri = () => {
  if (typeof window !== 'undefined') {
    return `${window.location.protocol}//${window.location.host}/clickup`
  }
  return `${getServerUri()}/clickup`
}

/** ClickUp OAuth client id from server env (per tenant), not from CRA build. */
export const fetchClickupClientId = async () => {
  if (cachedClientId) return cachedClientId
  const res = await fetch(`${getServerUri()}/api/public-config`)
  if (!res.ok) throw new Error('Nie udało się pobrać konfiguracji ClickUp')
  const data = await res.json()
  cachedClientId = data.clickupClientId || null
  return cachedClientId
}

export const buildClickupAuthLink = (clientId) => {
  if (!clientId) return null
  const redirect = encodeURIComponent(getClickupRedirectUri())
  return `https://app.clickup.com/api?client_id=${clientId}&redirect_uri=${redirect}`
}
